"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nupCampaignConfig = exports.TEST_ENROLL_END_AT = exports.ENROLL_END_AT = exports.TEST_CAMPAIGN_START_AT = exports.CAMPAIGN_START_AT = exports.MIN_AWARD_AMOUNT_HKD_CENTS = void 0;
exports.resolveUdpTagId = resolveUdpTagId;
exports.resolveActPlaybookId = resolveActPlaybookId;
exports.resolveCampaignStartAt = resolveCampaignStartAt;
exports.resolveEnrollEndAt = resolveEnrollEndAt;
exports.isEnrollOpen = isEnrollOpen;
exports.isActivityEnded = isActivityEnded;
/** 1 万 HKD = 1_000_000 港分 */
exports.MIN_AWARD_AMOUNT_HKD_CENTS = 1000000;
/** 净入金起点。正式 2026-09-01 00:00:00 GMT+8；测试 2026-08-01 00:00:00 GMT+8。 */
exports.CAMPAIGN_START_AT = 1788192000000;
exports.TEST_CAMPAIGN_START_AT = 1785513600000;
/** 正式报名截止：2026-10-31 23:59:59 GMT+8。 */
exports.ENROLL_END_AT = 1793462399000;
/** 测试报名截止与正式一致：2026-10-31 23:59:59 GMT+8。 */
exports.TEST_ENROLL_END_AT = 1793462399000;
exports.nupCampaignConfig = {
    campaignStartAt: {
        test: exports.TEST_CAMPAIGN_START_AT,
        prod: exports.CAMPAIGN_START_AT,
    },
    enrollEndAt: {
        test: exports.TEST_ENROLL_END_AT,
        prod: exports.ENROLL_END_AT,
    },
    depositPeriodDays: 15,
    udpTagId: {
        test: '807184-20260826115409-tag',
        prod: '590321-20260828110536-tag',
    },
    actPlaybookId: {
        test: '01a058f3-e125-718d-a6b9-b67bd737506a',
        prod: '01a047d2-2f8d-7124-a8f5-1067da4bf2f2',
    },
    featureName: 'futu_hk_nup_v2608_join_time',
    tiers: [
        {
            minAmount: 1000000,
            type: 'choice',
            strategyIds: {
                nvidia: {
                    test: '01a058f6-3f09-7318-a706-ba6c879aa633',
                    prod: '01a05721-7847-7568-83b2-e5576b784609',
                },
                btc: {
                    test: '01a058f6-a5ab-70ae-a225-18bb4a6c847a',
                    prod: '01a0572d-5d0e-733c-b4c3-7439ea941f65',
                },
                voucher: {
                    test: '01a058f5-59fe-73af-9a98-0051d543e33f',
                    prod: '01a0572c-ad98-748e-a600-7909f0505b7e',
                },
                hsbc: {
                    test: '01a058f5-9d9d-74ff-839e-ee3bbb66cecc',
                    prod: '01a0572d-1295-71ca-ad76-15f94199f632',
                },
            },
        },
        {
            minAmount: 15000000,
            type: 'fixed',
            strategyId: {
                test: '01a058f7-8677-77da-8ed9-9ba9f7cbb515',
                prod: '01a05725-aa24-76fe-863b-a4c587922ffb',
            },
        },
        {
            minAmount: 40000000,
            type: 'fixed',
            strategyId: {
                test: '01a058f8-bf1f-726f-9977-3a7d490e500a',
                prod: '01a05726-a73b-714e-83b3-49b01183a82d',
            },
        },
        {
            minAmount: 100000000,
            type: 'fixed',
            strategyId: {
                test: '01a058fb-61fa-7771-8502-129dc7e04978',
                prod: '01a05727-abc6-748a-8989-ebf8a43dd501',
            },
        },
        {
            minAmount: 500000000,
            type: 'fixed',
            strategyId: {
                test: '01a05901-2168-7058-a0f6-c92f276a72a4',
                prod: '01a05728-af0f-75a3-b63c-e03076954425',
            },
        },
        {
            minAmount: 1000000000,
            type: 'fixed',
            strategyId: {
                test: '01a05903-807e-7378-9d84-c9dcaa2f6a4c',
                prod: '01a05729-db87-73ea-91c5-cada9c082cd8',
            },
        },
        {
            minAmount: 2000000000,
            type: 'fixed',
            strategyId: {
                test: '01a05904-814f-74b9-b136-ad0b687327c8',
                prod: '01a0572a-a384-741d-9ccd-5dc72dbe7a91',
            },
        },
    ],
};
function resolveUdpTagId(config, isProdEnv) {
    return isProdEnv ? config.udpTagId.prod : config.udpTagId.test;
}
function resolveActPlaybookId(config, isProdEnv) {
    return isProdEnv ? config.actPlaybookId.prod : config.actPlaybookId.test;
}
function resolveCampaignStartAt(config, isProdEnv) {
    return isProdEnv ? config.campaignStartAt.prod : config.campaignStartAt.test;
}
function resolveEnrollEndAt(config, isProdEnv) {
    return isProdEnv ? config.enrollEndAt.prod : config.enrollEndAt.test;
}
function isEnrollOpen(nowMs, enrollEndAt) {
    return nowMs <= enrollEndAt;
}
/**
 * 报名已截止，且用户已无入金窗（未报名或 deposit_end_time 已过）。
 * 报名截止后仍在入金期内的用户不算活动结束。
 */
function isActivityEnded(nowMs, depositEndTime, enrollEndAt) {
    if (isEnrollOpen(nowMs, enrollEndAt)) {
        return false;
    }
    if (depositEndTime == null) {
        return true;
    }
    return nowMs >= depositEndTime;
}
